
    var riot = require('riot')
    //src: starling/src/tags/menu/buttons/menu-button-relationship-style.html
riot.tag2('menu-button-relationship-style',
  '<span ref="lineColor" data-tip="Line color & style" style="display: flex;"> <svg class="bulk-actions-menu-item_icon line-preview"> <path d="M 0 8 L 40 8" stroke-dasharray="{getLinePreviewStyle()}" stroke-width="{getLinePreviewWidth()}" stroke="{getLinePreviewColor()}"></path> </svg> </span> <svg class="bulk-actions-menu-item_arrow"> <use xlink:href="#caret-menu-icon"></use> </svg> <color-picker if="{this.isOpen}" positioning="left: 50%; top: calc(100% + 2px); transform: translateX(-50%);" colors="{relationshipColors}" setcolor="{setRelationshipColor}" setlinetype="{setLineType}" setlinewidth="{setLineWidth}" subject="relationship" type="bulk"></color-picker>',
  '',
  'class="bulk-actions-menu-item" onclick="{openRelationshipStylePicker}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _menuUi = require('lib/menu-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = this.parent.opts.canvas;

this.isOpen = false;
this.relationshipColors = _constants.LINK_COLORS;

this.setRelationshipColor = _menuUi.mui.setRelationshipColor.bind(this);
this.setLineType = _menuUi.mui.setLineType.bind(this);
this.setLineWidth = _menuUi.mui.setLineWidth.bind(this);
this.getBulkColor = _menuUi.mui.getBulkColor.bind(this);
this.getBulkLineType = _menuUi.mui.getBulkLineType.bind(this);
this.getBulkLineWidth = _menuUi.mui.getBulkLineWidth.bind(this);
this.getLinePreviewColor = _menuUi.mui.getLinePreviewColor.bind(this);
this.getLinePreviewStyle = _menuUi.mui.getLinePreviewStyle.bind(this);
this.getLinePreviewWidth = _menuUi.mui.getLinePreviewWidth.bind(this);

_menuUi.mui.registerMenuButton(this, 'relationshipStyle');

this.openRelationshipStylePicker = function (e) {
  if (_this.isOpen) {
    _this.refs.lineColor.removeAttribute('data-tip-hide');
    _this.isOpen = false;
    _this.update();
    _this.parent.unsetActiveTool(_this.refs.lineColor);

    _eventTracking2.default.track({
      category: 'Toolbar',
      action: 'Close-Line-Style-Menu',
      label: 'Close'
    });
  } else {
    canvas.hidePopups();
    _this.parent.resetTools();
    _this.refs.lineColor.setAttribute('data-tip-hide', 'true');
    _this.isOpen = true;
    _this.update();
    _this.parent.setActiveTool(_this.refs.lineColor);

    _eventTracking2.default.track({
      category: 'Toolbar',
      action: 'Open-Line-Style-Menu',
      label: 'Open'
    });
  }
};
this.hideSubMenu = function () {
  if (_this.isOpen) {
    _this.isOpen = false;
    _this.update();
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-button-relationship-style')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/buttons/menu-button-relationship-style.html
// module id = 718
// module chunks = 0